/* eslint-disable import/no-unresolved */
import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import { func, string } from "prop-types";

import { LoginSelectRegion } from "@ui-kit/components/index.es";
import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import * as i18n from "util/i18n";
import { getArray } from "util/config";

function RegionSelectionV3({ dispatch, activeRegion }) {
    const supportedRegions = useMemo(
        () => (getArray("frontend.regions") ? getArray("frontend.regions").sort() : []),
        [],
    );

    const regions = useMemo(
        () =>
            supportedRegions.map((idRegion) => ({
                id: idRegion,
                label: i18n.get(`settings.regions.label.${idRegion}`),
            })),
        [supportedRegions],
    );

    const handleSelectRegion = useCallback(
        (regionId) => {
            if (regionId !== activeRegion) {
                dispatch(loginActions.setRegion(regionId));
            }
        },
        [dispatch, activeRegion],
    );

    const getLabels = useCallback((key) => (key === "title" ? i18n.get("settings.changeRegion") : i18n.get(key)), []);

    return (
        <LoginSelectRegion
            regions={regions}
            activeRegion={activeRegion}
            onSelectRegion={handleSelectRegion}
            getLabels={getLabels}
        />
    );
}

RegionSelectionV3.propTypes = {
    dispatch: func.isRequired,
    activeRegion: string,
};

RegionSelectionV3.defaultProps = {
    activeRegion: "",
};

const mapStateToProps = (state) => ({
    activeRegion: loginSelectors.getRegion(state),
});

export default connect(mapStateToProps)(RegionSelectionV3);
